export const SET_IS_VALID_LOGIN = "SET_IS_VALID_LOGIN";
export const SET_TOKEN = "SET_TOKEN";
export const NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT";
export const NOTIFICATIONS_SUMMARIES = "NOTIFICATIONS_SUMMARIES";
export const IS_SHOW_NOTIFICATIONS_DETAIL = "IS_SHOW_NOTIFICATIONS_DETAIL";
export const IS_SHOW_ELECTRONIC_CONSENTS_DETAIL =
  "IS_SHOW_ELECTRONIC_CONSENTS_DETAIL";
export const CONTRACT_ID = "CONTRACT_ID";
export const CONTRACTS = "CONTRACTS";
export const CONTRACT_NUMBER = "CONTRACT_NUMBER";
export const CURRENT_NOTIFICATION_DATA = "CURRENT_NOTIFICATION_DATA";
export const LSS_BLOCK_NOTIFICATION_DATA = "LSS_BLOCK_NOTIFICATION_DATA";
export const CURRENT_NOTIFICATION_INDEX = "CURRENT_NOTIFICATION_INDEX";
export const IS_SHOW_ZET_LESSON_DETAIL = "IS_SHOW_ZET_LESSON_DETAIL";
export const ZET_LESSON_DETAIL_DATA = "ZET_LESSON_DETAIL_DATA";
export const IS_DEAD_LOCK = "IS_DEAD_LOCK";
export const DEAD_LOCK_MESSAGE = "DEAD_LOCK_MESSAGE";
export const IS_ASSIGNED = "IS_ASSIGNED";
export const VUZ_ID = "VUZ_ID";
export const SET_MENU = "SET_MENU";
export const RESET_STORE = "RESET_STORE";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
export const AUTH_ERROR = "AUTH_ERROR";
export const CHANGE_STEP = "CHANGE_STEP";
